import _ from 'lodash/fp';
import { combineEpics } from 'redux-observable';
import { actions } from 'reducers';
import api from 'api';
import authStatus from 'constants/auth-status';
import { error$ } from './util';

const isLoggedIn = _.flow(_.result('auth.status'), _.eq(authStatus.ANONYMOUS));

const listen$ = (action$, state) =>
  action$
    .ofAction(actions.auth.listen)
    .switchMap(api.auth.listen)
    .filter(_.isObjectLike)
    .switchMap(api.auth.checkAuthorized)
    .map(authData => {
      if (authData) return actions.auth.login(authData);
      else if (isLoggedIn(state)) return actions.auth.logout();
      return { type: 'NONE' };
    })
    .catch(error$)
    .retry();

const open$ = action$ =>
  action$
    .ofAction(actions.auth.open)
    .switchMap(api.auth.signInWithEmailAndPassword)
    .filter(
      ({ code }) =>
        code === 'auth/wrong-password' ||
        code === 'auth/invalid-email' ||
        code === 'auth/user-not-found'
    )
    .map(actions.auth.invalidLogin)
    .catch(error$)
    .retry();

const logout$ = action$ =>
  action$
    .ofAction(actions.auth.logout)
    .do(api.auth.signOut)
    .mapTo(actions.messages.pushSuccess('Logged out'))
    .catch(error$)
    .retry();

export default combineEpics(open$, listen$, logout$);



// WEBPACK FOOTER //
// ./src/epics/auth.js